import { BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

import Inventory2Icon from "@mui/icons-material/Inventory2";
import CurrencyPoundIcon from "@mui/icons-material/CurrencyPound";
import ListAltIcon from "@mui/icons-material/ListAlt";
import TuneIcon from "@mui/icons-material/Tune";
import PsychologyAltIcon from "@mui/icons-material/PsychologyAlt";

import {
  ProductsRoute,
  StockValueRoute,
  PurchaseOrdersRoute,
  AdjustStockRoute,
  CustomSalesRoute,
} from "../routes";

import { useUserRole } from "../hooks/useUserRole";

export const MobileBottomNavigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAdmin } = useUserRole();

  const allNavigationItems = [
    {
      label: "Inventory",
      route: ProductsRoute,
      icon: <Inventory2Icon />,
      requiresAdmin: false,
    },
    {
      label: "Stock Value",
      route: StockValueRoute,
      icon: <CurrencyPoundIcon />,
      requiresAdmin: true,  // ADMIN ONLY
    },
    {
      label: "Purchase Orders",
      route: PurchaseOrdersRoute,
      icon: <ListAltIcon />,
      requiresAdmin: false,
    },
    {
      label: "Adjust Stock",
      route: AdjustStockRoute,
      icon: <TuneIcon />,
      requiresAdmin: false,
    },
    {
      label: "Custom Sales",
      route: CustomSalesRoute,
      icon: <PsychologyAltIcon />,
      requiresAdmin: false,
    },
  ];

  // Filter navigation items based on user role
  const navigationItems = allNavigationItems.filter(
    item => !item.requiresAdmin || isAdmin
  );

  const getCurrentValue = () => {
    const currentPath = location.pathname;
    const matchingItem = navigationItems.find(item => 
      currentPath === item.route || 
      (currentPath === "/" && item.route === ProductsRoute)
    );
    return matchingItem ? navigationItems.indexOf(matchingItem) : 0;
  };

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    const selectedItem = navigationItems[newValue];
    if (selectedItem) {
      navigate(selectedItem.route);
    }
  };

  return (
    <Paper
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        width: "100%",
        display: { xs: "block", sm: "none" },
        zIndex: 1300,
        paddingBottom: "env(safe-area-inset-bottom)",
        WebkitTransform: "translateZ(0)",
        transform: "translateZ(0)",
        WebkitBackfaceVisibility: "hidden",
        backfaceVisibility: "hidden",
      }}
      elevation={3}
    >
      <BottomNavigation
        value={getCurrentValue()}
        onChange={handleChange}
        showLabels={false}
      >
        {navigationItems.map((item, index) => (
          <BottomNavigationAction
            key={index}
            icon={item.icon}
            aria-label={item.label}
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
};